module.exports = __webpack_public_path__ + "static/project-management-web-app-cover-049c0187e64c9fed9269cdfd266927c7.png";